import { Context, Id, enumMapToSame, mapDtoToEntity, throwNotImplemented } from '../../../common'
import { AddRoleOpts, Role, RoleType, RolesService, UpdateRoleOpts } from './roles'
import { Api, HttpClient, RolesApi } from '../../../api'

function mapDtoToRole(dto: Api.Role): Role {
  return mapDtoToEntity({
    ...dto,
    type: enumMapToSame<Api.Role.Type, RoleType>(dto.type),
  })
}

export class RemoteRolesService implements RolesService {
  private api: RolesApi

  constructor(httpClient: HttpClient) {
    this.api = new RolesApi(httpClient, undefined, '')
  }

  async findAll(ctx: Context): Promise<Role[]> {
    const result = await this.api.rolesGetList(ctx)
    return result.body.items.map(mapDtoToRole)
  }

  async getById(ctx: Context, id: string): Promise<Role> {
    const result = await this.api.rolesGetById(ctx, id)
    return mapDtoToRole(result.body.object)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  findByIdNonDeleted(ctx: Context, id: string): Promise<Role | undefined> {
    throwNotImplemented('<27c83bc5>')
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  add(ctx: Context, opts: AddRoleOpts): Promise<Id> {
    throwNotImplemented('<23232b7c>')
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  update(ctx: Context, id: string, opts: UpdateRoleOpts): Promise<void> {
    throwNotImplemented('<5d2f2d34>')
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async addPermissions(ctx: Context, id: string, permissions: string[]): Promise<void> {
    throwNotImplemented('<e326aca6>')
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async deletePermissions(ctx: Context, id: string, permissions: string[]): Promise<void> {
    throwNotImplemented('<9a84dfd4>')
  }
}
